(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["happysoy-campaign-header"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!document.body.classList.contains('hsa-campaign')) return;
  const closingDialogs = new WeakSet();
  let queued = false;
  const closeCampaignPopup = () => {
    queued = false;
    document.querySelectorAll('form[data-testid="klaviyo-form-QVdBds"]').forEach(form => {
      const dialog = form.closest('[role="dialog"][aria-label="POPUP Form"]');
      if (!dialog || dialog.style.display === 'none' || closingDialogs.has(dialog)) return;
      const close = dialog.querySelector('button.klaviyo-close-form[aria-label="Close dialog"]');
      if (!close) return;
      closingDialogs.add(dialog);
      close.click();
      requestAnimationFrame(() => closingDialogs.delete(dialog));
    });
  };
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(closeCampaignPopup);
  });
  observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style']});
  closeCampaignPopup();
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["happysoy-collection-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hs-filter-toggle]');
    if (!button) return;
    button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !window.matchMedia('(max-width: 749px)').matches) return;
    const host = event.target.closest('.hs-visible-filters');
    const button = host?.querySelector('[data-hs-filter-toggle]');
    if (!button || button.getAttribute('aria-expanded') !== 'true') return;
    button.setAttribute('aria-expanded', 'false');
    button.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["happysoy-legal-notice"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-hs-legal-open]');
    if (!opener || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const dialog = document.getElementById('HsLegalNotice');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    dialog.showModal();
    dialog.scrollTop = 0;
    const closeButton = dialog.querySelector('[data-hs-legal-close]');
    closeButton.focus({ preventScroll: true });
    const close = () => dialog.close();
    const outside = (e) => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); } };
    closeButton.addEventListener('click', close);
    dialog.addEventListener('click', outside);
    dialog.addEventListener('close', () => {
      closeButton.removeEventListener('click', close);
      dialog.removeEventListener('click', outside);
      if (opener.isConnected) opener.focus({ preventScroll: true });
    }, { once: true });
  });
  } catch(e) { console.error(e); }
})();

})();
